import EditorField from "./EditorField";
import editorForm from "./editorForm";
import VarScript from "./VarScript";
import deepClone from "../../../../config/deepCopy.js";

import eventTriggerMap from "../Config/eventTriggerMap"
import eventActionMap from "../Config/eventActionMap.js"
import API from "../../../../config/api";

// 每个组件特定的的编辑器组件都要引用该mixin，该mixin包含了编辑器的通用模板以及一些通用方法，
// 引用mixin后，特定的编辑器就不需要再写模板，只需要实现specificForms这个计算属性，返回表单，就可以填充到正确位置。
export default {
    // eslint-disable-next-line no-unused-vars
    render(createElement, context) {
        return (
            <div class={['editor', this.$options.name]}>
                <div class="forms" id="attForms">
                    <el-collapse ref="collapse" head-style={this.collapseHeadStyle} value={this.activeNames}
                                 {...{
                                     on: {
                                         'change': (val)=>{
                                             this.$emit('update:activeNames', val)
                                         },
                                     }
                                 }}
                    >
                        {/*
						一些每个组件都会有的设置放在通用表单里
						如堆叠顺序等
					*/}
                        {
                            this.universalForm
                        }
                        {/*
						不同组件特有的设置
					*/}
                        {
                            this.specificForms
                        }
                        {/*
							按钮页面跳转
						*/}
                        {/*{*/}
                        {/*    this.jumpForms*/}
                        {/*}*/}
                        {
                            this.clickForms
                        }

                        {/*
						对变量控制事件
					*/}
                        {/*{*/}
                        {/*    this.variablesEventForms*/}
                        {/*}*/}
                    </el-collapse>

                </div>
            </div>
        )
    },
    components: {EditorField, editorForm,VarScript},
    props: {
        settings: Object,
        realtimeData: Object,
        _style: Object,
        wrapperStyle: Object,
        type: String,
        elementsList: Array,
        events: Array,  // 组件控制事件
        variableEvents: Array,  // 变量控制事件
        clickEvents: Array,
        varList: Array,
        varJson: Object,
        attrDialog: Object,
        bindInfo: Object,
        projectId: Number | String,
        companyId: Number | String,
        activeNames: Array,
        scollLen: Number | String
    },
    data() {
        return {
            // props中的settings的拷贝，用于绑定表单。
            editingLeft: 0,
            editingTop: 0,
            newSettings: {},
            newVariablesEvents: [],  // 变量控制
            newClickEvents: [],    // 点击事件
            newBindInfo: {},
            styleMergeObj: {},
            wrapperStyleMergeObj: {},
            eventTriggerList: [],
            labelPosition: 'left',   //提示文字相对于编辑框的位置
            // universalFormRule2:{
            // 	"top": [
            // 		{
            // 			required: true,
            // 			message: '堆叠顺序不能为空'
            // 		},
            // 		{
            // 			validator: (rule, value, callback) => {
            // 				return /^\d+$/.test(value) && value < 10000;
            // 			},
            // 			message: '堆叠顺序的取值范围为[0, 9999)'
            // 		}
            // 	],
            // 	"left": [
            // 		{

            // 		}
            // 	]
            // },
            universalFormRule: {
                "top": [
                    {}
                ],
                "left": [
                    {}
                ],
                "z-index": [
                    {
                        required: true,
                        message: '堆叠顺序不能为空'
                    },
                    {
                        // eslint-disable-next-line no-unused-vars
                        validator: (rule, value, callback) => {
                            return /^\d+$/.test(value) && value < 10000;
                        },
                        message: '堆叠顺序的取值范围为[0, 9999)'
                    }
                ],
                // "width": [
                // 	{
                // 		type: 'number',
                // 		message: '组件宽度输入数字',
                // 	}
                // ],
                // "height": [
                // 	{
                // 		type: 'number',
                // 		message: '组件高度输入数字',
                // 	}
                // ],
            },
            // 供特定编辑器组件重写，每有一个表单就把它的id/ref写进去
            formList: [
                // ...
                // 'universalForm2',
                // 'universalForm'
            ],
            // 供特定编辑器组件重写，与上面的formList一一对应
            ruleList: [
                // 'universalFormRule2',
                // 'universalFormRule'
            ],
            collapseHeadStyle: {
                "font-weight": 'bolder',
                'font-size': '16px',
            },
            formLabelStyle: {
                "font-weight": 'bolder',
            },
            selectList1:[
                {
                    value: 0,
                    label: '子窗口'
                }, {
                    value: 1,
                    label: '全窗口'
                },
            ],
            selectList3: [],   //跳转页面的选择列表，模态
            selectList4:[],//跳转页面的选择列表，非模态
            border: true,  //有边框
            height: 30,    //输入框的大小

            scollInterval: {},    // 获取滚动条定时器
            scollLenToUse: 0,    // 滚动条的值
        }
    },
    computed: {
        // 由特定的编辑器组件重写
        specificForms() {
            return (
                <div>
                </div>
            )
        },
        editingId() {
            return this.attrDialog.componentId
        },
        // 通用
        universalForm() {
            return (
                <div class="specificForms">
                    <el-collapse-item class="specificForm" title="通用配置" open={true} name="1">
                        <template slot="default">
                            <div class="specificForm">
                                <el-form id="universalForm" props={{model: this.newSettings}} ref="universalForm"
                                         rules={this.universalFormRule} label-style={this.formLabelStyle} hide-required-asterisk={true}>
                                    {/*把x和y放在同一行*/}
                                    <el-row>
                                        <el-col span={12}>
                                            <el-form-item label="x" prop="top" label-position={this.labelPosition}>
                                                <editor-field {...{
                                                    attrs: {
                                                        value: this.newSettings.left,
                                                        type: 'input',
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false
                                                    }
                                                }}{...{
                                                    on: {
                                                        'input': val => {
                                                            this.newSettings.left= val
                                                            this.handleConfirmBtnClick()
                                                        },
                                                    }
                                                }}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                        <el-col span={12}>
                                            <el-form-item label="y" prop="left" label-position={this.labelPosition}>
                                                <editor-field {...{
                                                    attrs: {
                                                        // value: Number(this.editingLeft),
                                                        value: this.newSettings.top,
                                                        type: 'input',
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false,
                                                        // InputType: 'number',
                                                    }
                                                }}{...{
                                                    on: {
                                                        'input': val => {
                                                            this.newSettings.top = val
                                                            this.handleConfirmBtnClick()
                                                        },
                                                    }
                                                }}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col span={12}>
                                            <el-form-item label="宽" prop="width" label-position={this.labelPosition}>
                                                <editor-field {...{
                                                    attrs: {
                                                        value: this.newSettings.width,
                                                        type: 'input',
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false,
                                                    }
                                                }}{...{
                                                    on: {
                                                        'input': val => {
                                                            this.handleUniversalChangeSize(val, 'width')
                                                            this.handleConfirmBtnClick()
                                                        },
                                                    }
                                                }}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                        <el-col span={12}>
                                            <el-form-item label="高" prop="height" label-position={this.labelPosition}>
                                                <editor-field {...{
                                                    attrs: {
                                                        value: this.newSettings.height,
                                                        type: 'input',
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false,
                                                    }
                                                }}{...{
                                                    on: {
                                                        'input': val => {
                                                            this.handleUniversalChangeSize(val, 'height')
                                                            this.handleConfirmBtnClick()
                                                        },
                                                    }
                                                }}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col span={12}>
                                            <el-form-item label="层级" prop="z-index" label-position={this.labelPosition}>
                                                <editor-field {...{
                                                    attrs: {
                                                        value: this.newSettings["z-index"],
                                                        type: 'input',
                                                        index:true,
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false,
                                                    }
                                                }}{...{
                                                    on: {
                                                        'input': val => {
                                                            this.newSettings["z-index"] = val;
                                                            this.handleUniversalChange(val, 'z-index')
                                                            this.handleConfirmBtnClick()
                                                        },
                                                    }
                                                }}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                        <el-col span={12}>
                                            <el-form-item label="锁定" prop="isLock" label-position={this.labelPosition}>
                                                <editor-field {...{attrs: {
                                                        value: this.newSettings.isLock,
                                                        type: 'switch',
                                                        varList: this.varList,
                                                        varJson: this.varJson,
                                                        showEditButton: false,
                                                    }}}{...{on: {
                                                        'input': val => {
                                                            this.$set(this.newSettings, 'isLock', val)
                                                            this.handleConfirmBtnClick()
                                                        }
                                                    }}}>
                                                </editor-field>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-form-item label="可视性" prop="state" label-position={this.labelPosition}>
                                        <editor-field {...{attrs: {
                                                value: this.newSettings.state,
                                                type: 'switch',
                                                varList: this.varList,
                                                varJson: this.varJson,
                                                showEditButton: true,
                                                label: "可视性",
                                            }}}{...{on: {
                                                'input': val => {
                                                    this.$set(this.newSettings, 'state', val)
                                                    this.handleConfirmBtnClick()
                                                }
                                            }}}>
                                        </editor-field>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </template>
                    </el-collapse-item>
                </div>
            )
        },

        variablesEventForms() {
            return (
                // <el-collapse-item class="variablesEventForms" title="变量控制" itemStyle={{height: '180px'}}
                //                   ref="variablesEventForms" name="5">

                    <div class="variablesList">
                        {
                            this.variablesEventList
                        }
                        <el-button type="primary" size="small" className="addEventBtn" {...{
                            on: {
                                'click': this.handleAddVariablesEventBtnClick
                            }
                        }}>
                            <i class="el-icon-edit"></i>添加变量控制
                        </el-button>
                    </div>
                // </el-collapse-item>
            )
        },
        variablesEventList() {
            if (this.newVariablesEvents.length === 0) { return
                // return (
                //     <div style={{height: "40px", "line-height": '40px', "text-align": 'center'}}>无事件</div>
                // )
            } else {
                return this.newVariablesEvents.map((event) => {
                    event.trigger = "click"
                    return (
                        <div class="variablesEventItem">
                            <div style={{marginTop: "5px",marginBottom: "5px"}}>
                                <el-row>
                                    <el-col span={1}>
                                        <span>令</span>
                                    </el-col>
                                    <el-col span={8}>
                                        <el-select style={{width: "90px"}} size="mini"
                                            {...{
                                                attrs: {
                                                    value: event.variable,  // 存放变量name
                                                }
                                            }}
                                            {...{
                                                on: {
                                                    'input': val => {
                                                        event.variable = val
                                                        this.handleConfirmBtnClick()
                                                    },
                                                }
                                            }}>
                                            {/*[*/}
                                            {/*(*/}
                                            <el-option label="" value="请选择变量"></el-option>
                                            {/*),*/}
                                            {
                                                ...this.varList.map(variable => {
                                                    return variable.name === event.variable ? (
                                                        <el-option label={variable.name} value={variable.name} selected={true}>{variable.name}</el-option>
                                                    ) : (
                                                        <el-option label={variable.name} value={variable.name}>{variable.name}</el-option>
                                                    )
                                                })
                                            }
                                            {/*]*/}
                                        </el-select>
                                    </el-col>
                                    <el-col span={1}>
                                        <span> = </span>
                                    </el-col>
                                    <el-col span={8}>
                                        <el-input size="mini" readonly
                                                  {...{
                                                      attrs: {
                                                          value: event.content,
                                                      }
                                                  }}
                                                  placeholder="输入数值"
                                                  type="text"
                                        >
                                        </el-input>
                                    </el-col>
                                    <el-col span={3}>
                                        <el-button type="primary" size="mini" circle style={{marginLeft: "2px"}} icon="el-icon-edit"
                                            {...{
                                                   on: {
                                                       'click':() => {
                                                           event.show = true
                                                           //this.handleConfirmBtnClick()
                                                       },
                                                   }
                                            }}
                                        />
                                    </el-col>
                                    <el-col span={3}>

                                    </el-col>
                                </el-row>
                                <var-script
                                    {...{attrs: {
                                        show: event.show,
                                        contentOri: event.content,
                                        varList:this.varList
                                    }}}
                                    {...{
                                        on: {
                                            'close':val => {
                                                event.show = val
                                                //this.handleConfirmBtnClick()
                                            },
                                            'setContent': val => {
                                                event.content = val
                                            }
                                        }
                                    }}
                                >
                                </var-script>
                            </div>
                        </div>
                    )
                })
            }
        },

        jumpForms() {
            return (
                // <div class="jumpForms">
                //     <el-collapse-item class="jumpForms" title="跳转页面效果" name="3">
                //         <template slot="default">
                <div class="jumpForms">
                    <div class="div">
                        <select
                            {...{attrs: {
                                    value: this.newSettings.selectValue1,
                                }}}
                            {...{on: {
                                    'input': e => {
                                        this.newSettings.selectValue1 = e.target.value;
                                        console.log("设置selectValue1的值",this.newSettings.selectValue1)
                                        this.newSettings.pageId = '';
                                        if(document.getElementById('pageList')){
                                            document.getElementById('pageList').selectedIndex = 0;
                                        }
                                        if(document.getElementById('varList')){
                                            document.getElementById('varList').selectedIndex = 0;
                                        }
                                        this.handleConfirmBtnClick()
                                    }
                                }
                            }}
                            style={{marginLeft:'5px',marginBottom:'3px',width:'110px' }}>
                            {
                                [
                                    // (<option value="">跳转方式</option>),
                                    ...this.selectList1.map(item => {
                                        return item.value == this.newSettings.selectValue1 ? (
                                            <option value={item.value} selected={true}>{item.label}</option>
                                        ) : (
                                            <option value={item.value}>{item.label}</option>
                                        )
                                    })
                                ]

                            }
                        </select>

                        {
                            this.newSettings.selectValue1==0 ? (
                                    <select id='pageList'
                                            {...{attrs: {
                                                    value: this.newSettings.pageId,
                                                }}}
                                            {...{on: {
                                                    'input': e => {
                                                        this.newSettings.pageId =e.target.value
                                                        this.btnFlag(e.target.value)
                                                        this.handleConfirmBtnClick()
                                                    }
                                                }
                                            }}
                                            style={{marginLeft:'5px',width:'110px' }}>
                                        {
                                            [
                                                (<option value="">页面选择</option>),
                                                ...this.selectList3.map(item => {
                                                    return item.id == this.newSettings.pageId ? (
                                                        <option value={item.id} selected={true}>{item.title}</option>
                                                    ) : (
                                                        <option value={item.id}>{item.title}</option>
                                                    )
                                                })
                                            ]

                                        }
                                    </select>

                                )
                                : (
                                    <select id='pageList'
                                            {...{attrs: {
                                                    value: this.newSettings.pageId,
                                                }}}
                                            {...{on: {
                                                    'input': e => {
                                                        this.newSettings.pageId =e.target.value
                                                        this.btnFlag(e.target.value)
                                                        this.handleConfirmBtnClick()
                                                    }
                                                }
                                            }}
                                            style={{marginLeft:'5px',width:'110px' }}>
                                        {
                                            [
                                                (<option value="">页面选择</option>),
                                                ...this.selectList4.map(item => {
                                                    return item.id == this.newSettings.pageId ? (
                                                        <option value={item.id} selected={true}>{item.title}</option>
                                                    ) : (
                                                        <option value={item.id}>{item.title}</option>
                                                    )
                                                })
                                            ]

                                        }
                                    </select>
                                )
                        }
                        {
                            this.newSettings.selectValue1==0 ? (
                                    <div style={{marginTop:'5px',marginLeft:'5px',width:'117px',display: 'inline-block' }}>
                                        <el-input  border-color="#000000"
                                                   type="number" min="0" border={this.border}  height={this.height}  placeholder="模态窗宽度"
                                            // v-model={this.newSettings.modalValue}
                                                   {...{
                                                       attrs: {
                                                           value: this.newSettings.modalValue,
                                                       }
                                                   }}
                                                   {...{
                                                       on: {
                                                           'input': val => {
                                                               this.newSettings.modalValue = val
                                                               this.handleConfirmBtnClick()
                                                           },
                                                       }
                                                   }}
                                        />

                                    </div>

                                )
                                : (
                                    <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
                                        <el-input clearable={true} border-color="#000000"
                                                  type="number" min="0" border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
                                        />
                                    </div>
                                )
                        }
                        {
                            this.newSettings.selectValue1==0 ? (
                                    <div style={{marginTop:'5px',marginLeft:'5px',width:'117px',display: 'inline-block' }}>
                                        <el-input  border-color="#000000"
                                                   type="number"  min="0"  border={this.border}  height={this.height}  placeholder="模态窗高度"
                                            // v-model={this.newSettings.modalHeight}
                                                   {...{
                                                       attrs: {
                                                           value: this.newSettings.modalHeight,
                                                       }
                                                   }}
                                                   {...{
                                                       on: {
                                                           'input': val => {
                                                               this.newSettings.modalHeight = val
                                                               this.handleConfirmBtnClick()
                                                           },
                                                       }
                                                   }}
                                        />
                                    </div>

                                )
                                : (
                                    <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
                                        <el-input clearable={true} border-color="#000000"
                                                  type="number"  min="0"  border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
                                        />
                                    </div>
                                )
                        }
                        {
                            this.newSettings.selectValue1==0 ? (
                                    <div style={{marginTop:'5px',marginLeft:'5px',width:'117px',display: 'inline-block' }}>
                                        <el-input  border-color="#000000"
                                                   type="number" min="0" border={this.border}  height={this.height}  placeholder="x"
                                                   {...{
                                                       attrs: {
                                                           value: this.newSettings.modalX,
                                                       }
                                                   }}
                                                   {...{
                                                       on: {
                                                           'input': val => {
                                                               this.newSettings.modalX = val
                                                               this.handleConfirmBtnClick()
                                                           },
                                                       }
                                                   }}
                                        />
                                    </div>

                                )
                                : (
                                    <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
                                        <el-input clearable={true} border-color="#000000"
                                                  type="number"  min="0"  border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
                                        />
                                    </div>
                                )
                        }
                        {
                            this.newSettings.selectValue1==0 ? (
                                    <div style={{marginTop:'5px',marginLeft:'5px',width:'117px',display: 'inline-block' }}>
                                        <el-input  border-color="#000000"
                                                   type="number" min="0"  border={this.border}  height={this.height}  placeholder="y"
                                                   {...{
                                                       attrs: {
                                                           value: this.newSettings.modalY,
                                                       }
                                                   }}
                                                   {...{
                                                       on: {
                                                           'input': val => {
                                                               this.newSettings.modalY = val
                                                               this.handleConfirmBtnClick()
                                                           },
                                                       }
                                                   }}
                                        />
                                    </div>

                                )
                                : (
                                    <div style={{width:'110px',marginTop:'5px',marginLeft:'5px',display: 'inline-block'}}>
                                        <el-input clearable={true} border-color="#000000"
                                                  type="number" min="0" border={this.border}  height={this.height}  disabled={true} placeholder="禁止输入"
                                        />
                                    </div>
                                )
                        }
                    </div>
                </div>
                //         </template>
                //     </el-collapse-item>
                // </div>
            )
        },

        clickEventList() {
            if (this.newClickEvents.length === 0) {
                return (
                    <div style={{height: "40px", "line-height": '40px', "text-align": 'center'}}>无事件</div>
                )
            }
            return this.newClickEvents.map((event,idx) => {
                return (
                    <div class="clickEventItem">
                        <el-row style={{marginBottom: "20px",marginTop: "20px"}}>
                            <el-col span={4}>
                                <span>类型：</span>
                            </el-col>
                            <el-col span={13}>
                                <el-select size="mini" style={{width:"100%"}} {...{
                                    attrs: {
                                        value: event.kind,
                                    }
                                }}{...{
                                    on: {
                                        'input': val => {
                                            event.kind = val;
                                        },
                                    }
                                }} placeholder="请选择"
                                >
                                    <el-option label="变量控制" value="变量控制"/>
                                    <el-option label="执行脚本" value="执行脚本"/>
                                    <el-option label="页面跳转" value="页面跳转"/>
                                </el-select>


                                {/*<el-radio-group size="small" {...{*/}
                                {/*attrs: {*/}
                                {/*    value: event.kind,*/}
                                {/*}*/}
                                {/*    }}{...{*/}
                                {/*    on: {*/}
                                {/*        'input': val => {*/}
                                {/*            event.kind = val;*/}
                                {/*        },*/}
                                {/*    }*/}
                                {/*}}>*/}
                                {/*    <el-row>*/}
                                {/*        <el-col span={8}>*/}
                                {/*            <el-radio label="变量控制">变量控制</el-radio>*/}
                                {/*        </el-col>*/}
                                {/*        <el-col span={8}>*/}
                                {/*            <el-radio label="执行脚本">执行脚本</el-radio>*/}
                                {/*        </el-col>*/}
                                {/*        <el-col span={8}>*/}
                                {/*            <el-radio label="页面跳转">页面跳转</el-radio>*/}
                                {/*        </el-col>*/}
                                {/*    </el-row>*/}
                                {/*</el-radio-group>*/}
                                {/*<input type="radio" name="kind" {...{*/}
                                {/*    attrs: {*/}
                                {/*       value: event.kind,*/}
                                {/*    }*/}
                                {/*}}{...{*/}
                                {/*    on: {*/}
                                {/*       'input': e => {*/}
                                {/*           event.kind = e.target.value;*/}
                                {/*           this.handleConfirmBtnClick()*/}
                                {/*       },*/}
                                {/*    }*/}
                                {/*}} value="变量控制" checked={event.kind==="变量控制"}/>变量控制*/}
                                {/*<input type="radio" name="kind" {...{*/}
                                {/*    attrs: {*/}
                                {/*        value: event.kind,*/}
                                {/*    }*/}
                                {/*}}{...{*/}
                                {/*    on: {*/}
                                {/*        'input': e => {*/}
                                {/*            event.kind = e.target.value;*/}
                                {/*            this.handleConfirmBtnClick()*/}
                                {/*        },*/}
                                {/*    }*/}
                                {/*}} value="执行脚本" checked={event.kind==="执行脚本"}/>执行脚本*/}
                                {/*<input type="radio" name="kind" {...{*/}
                                {/*    attrs: {*/}
                                {/*        value: event.kind,*/}
                                {/*    }*/}
                                {/*}}{...{*/}
                                {/*    on: {*/}
                                {/*        'input': e => {*/}
                                {/*            event.kind = e.target.value;*/}
                                {/*            this.handleConfirmBtnClick()*/}
                                {/*        },*/}
                                {/*    }*/}
                                {/*}} value="页面跳转" checked={event.kind==="页面跳转"}/>页面跳转*/}
                            </el-col>
                            <el-col span={1} style={{marginLeft: "30px"}}>
                                <el-button type="danger" size="mini" circle icon="el-icon-delete"{...{
                                    on: {
                                        'click': () => {
                                            this.handleDeleteClick(event,idx)
                                            this.handleConfirmBtnClick()
                                        }
                                    }
                                }}>
                                </el-button>
                            </el-col>
                        </el-row>
                        {this.getInfo(event)}
                    </div>
                )
            })
        },
        clickEventForms() {
            return (
                <div class="clickList">
                    {
                        this.clickEventList
                    }
                    <el-button style={{marginTop: "20px"}} type="primary" size="small" className="addEventBtn" {...{
                        on: {
                            'click': this.handleAddClickEventBtnClick
                        }
                    }}>
                        <i icon="el-icon-edit">
                        </i>添加点击事件
                    </el-button>
                </div>
            )
        },
        clickForms() {
            return (
                <div class="clickForms">
                    <el-collapse-item class="clickForms" title="点击事件" name="3">
                        <template slot="default">
                            {this.clickEventForms}
                        </template>
                    </el-collapse-item>
                </div>
            )
        },
    },

    created() {    // 页面还没开始渲染的时候，就准备好数据
        this.init()
    },
    mounted() {
        console.log("从这里看projectId1",this.projectId)
        this.newInit();    // 初始化模态跳转页面列表
        this.$bus.$on('saveInfo',this.handleConfirmBtnClick)   // 挂载保存的函数
        this.scollLenToUse = this.scollLen    // 获取属性框滚动的位置
        document.getElementById("attForms").scrollTop = this.scollLenToUse   // 设置位置
        this.scollInterval = setInterval(()=>{
            this.scollLenToUse = document.getElementById("attForms").scrollTop   // 设置定时器获取位置
        }, 1000)
    },
    beforeDestroy() {
        clearInterval(this.scollInterval);    // 清除定时器
        this.$emit("update:scollLen",this.scollLenToUse)   // 最后更新一下属性框滚动的位置
        this.$bus.$off('saveInfo');     // 清除保存信息的函数
    },
    methods: {
        init() {
            this.editingTop = this.wrapperStyle.top.replace('px', '')
            this.editingLeft = this.wrapperStyle.left.replace('px', '')

            // 把settings深拷贝一份供form进行绑定
            //this.settings.width = this._style.width.replace('px','')
            //this.settings.height = this._style.height.replace('px','')
            this.realtimeData.width = this._style.width.replace('px', '')
            this.realtimeData.height = this._style.height.replace('px', '')
            this.newSettings = deepClone(this.settings)            // 将settings拷贝一份到newSettings上,记录编辑框的变化
            this.$set(this.newSettings,"top",this.editingTop)       // 给newSetting加上x,y属性
            console.log("初始化newSettings的值为",this.newSettings)
            this.$set(this.newSettings,"left",this.editingLeft)
            this.styleMergeObj = deepClone(this._style)
            console.log('打开编辑器时style的值', this.styleMergeObj)
            console.log('打开编辑器时settings的值', this.settings)
            // this.wrapperStyleMergeObj = deepClone(this.wrapperStyle)
            // 把events深拷贝一份
            this.newEvents = deepClone(this.events)
            // 把variableEvents深拷贝一份
            this.newVariablesEvents = deepClone(this.variableEvents)
            this.newClickEvents = deepClone(this.clickEvents)
            this.eventTriggerList = eventTriggerMap[this.type] ? eventTriggerMap[this.type] : []
            // 注册所有规则,具体的组件编辑文件中编写相应的formList,并设置规则  现在规则由具体的组件设置
            // this.formList.forEach((form, idx) => {
            // 	this.$refs[form].setRules(this.ruleList[idx])
            // })
            //this.$refs["universalForm"].setRules(this.universalFormRule)
            // this.$refs["universalForm2"].setRules(this.universalFormRule2)
            // this.$nextTick(() => {
            //     if (this.$refs.eventsCollapseItem)
            //         this.$refs.eventsCollapseItem.init()
            // })
        },
        btnFlag(val){
            if(val === ''){
                this.newSettings.flag = false
            }
            else{
                this.newSettings.flag = true
            }
            if(this.newSettings.selectValue1==0){
                for(let i=0;i<this.selectList3.length;i++){
                    if(this.selectList3[i].id === val){
                        this.newSettings.product_type = this.selectList3[i].product_type;
                        this.newSettings.projectId = this.selectList3[i].projectId;
                    }
                }
            }
            if(this.newSettings.selectValue1!==0){
                for(let i=0;i<this.selectList4.length;i++){
                    if(this.selectList4[i].id === val){
                        this.newSettings.product_type = this.selectList4[i].product_type;
                        this.newSettings.projectId = this.selectList4[i].projectId;
                    }
                }
            }

        },
        getInfo(event) {     // 根据事件的不同类型，返回不同的子模块
            if (event.kind === "页面跳转") return this.jumpForms;
            else if (event.kind === "变量控制") return this.variablesItem(event);
            else if (event.kind === "执行脚本") return this.scriptItem(event);
        },
        variablesItem(event) {
            return (
                <div class="variablesEventItem">
                    <div style={{marginTop: "5px",marginBottom: "5px"}}>
                        <el-row>
                            <el-col span={2}>
                                <span>令</span>
                            </el-col>
                            <el-col span={18}>
                                {/*去掉了下面原本的style={{width: "190px"}}*/}
                                <el-select  style={{"margin-bottom": "5px"}} size="mini" filterable
                                           {...{
                                               attrs: {
                                                   value: event.variable,  // 存放变量name
                                               }
                                           }}
                                           {...{
                                               on: {
                                                   'input': val => {
                                                       event.variable = val
                                                       event.id = this.getId(val)
                                                       this.handleConfirmBtnClick()
                                                   },
                                               }
                                           }}>
                                    {/*[*/}
                                    {/*(*/}
                                    {/*<el-option label="" value="请选择变量"></el-option>*/}
                                    {/*),*/}
                                    {
                                        ...this.varList.map(variable => {
                                            return variable.name === event.variable ? (
                                                <el-option label={variable.name} value={variable.name} selected={true}>{variable.name}</el-option>
                                            ) : (
                                                <el-option label={variable.name} value={variable.name}>{variable.name}</el-option>
                                            )
                                        })
                                    }
                                    {/*]*/}
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col span={2}>
                                <span> = </span>
                            </el-col>
                            <el-col span={18}>
                                <el-input size="mini"
                                          {...{
                                            attrs: {
                                              value: event.value,
                                            }
                                          }}{...{
                                            on: {
                                                'input': (val) => {
                                                    event.value = val;
                                                    this.handleConfirmBtnClick()
                                                },
                                            }
                                          }}
                                          placeholder="输入数值"
                                          type="text"
                                >
                                </el-input>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            )
        },
        scriptItem(event){
            return (
                <div class="scriptItem">
                    <el-row>
                        <el-col span={20}>
                            <el-input size="mini" readonly
                                      {...{
                                          attrs: {
                                              value: event.content,
                                          }
                                      }}
                                      placeholder="输入脚本"
                                      type="text"
                            >
                            </el-input>
                        </el-col>
                        <el-col span={2}>
                            <el-button type="primary" size="mini" circle style={{marginLeft: "2px"}} icon="el-icon-edit"
                                       {...{
                                           on: {
                                               'click':() => {
                                                   event.show = true
                                                   //this.handleConfirmBtnClick()
                                               },
                                           }
                                       }}
                            />
                        </el-col>
                    </el-row>
                    <var-script
                        {...{attrs: {
                                show: event.show,
                                event: event,
                                varList:this.varList,
                                companyId:this.companyId
                            }}}
                        {...{
                            on: {
                                'close':val => {
                                    event.show = val
                                    this.handleConfirmBtnClick()
                                },
                                'setInfo': (content,id,triId) => {
                                    //console.log("设置参数",content,id,triId)
                                    event.content = content
                                    event.id = id
                                    event.triId = triId
                                }
                            }
                        }}
                    >
                    </var-script>

                </div>
            )
        },
        newInit(){    // 获取已发布页面
            let header = {
                "Content-Type": "application/x-www-form-urlencoded",
            }
            let data = {
                companyId: this.companyId,
                projectId: this.projectId,
                product_type: 0
            }
            this.$axiosRequest({
                url: API.getProductPublishedList,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    this.selectList3 = res.data["productPublishedList"]
                }
            });

            let header1 = {
                "Content-Type": "application/x-www-form-urlencoded",
            }
            let data1 = {
                companyId: this.companyId,
                projectId: this.projectId
            }
            this.$axiosRequest({
                url: API.getProductPublishedList,
                method: 'POST',
                data: data1,
                header: header1,
                success: res => {
                    this.selectList4 = res.data["productPublishedList"]
                }
            });
        },
        handleResetBtnClick() {
            // 复原是指修改了一些设置而还没点击确认时，将设置复原
            this.init()
        },
        handleDeleteClick(event,idx) {
            if (event.kind === "页面跳转") {
                this.newSettings.selectValue1 = ''
                this.newSettings.pageId = ''
                this.newSettings.modalValue = ''
                this.newSettings.modalHeight = ''
                this.newSettings.flag = false
            }
            this.newClickEvents.splice(idx, 1)
        },
        // 在编辑器中做的修改在点击确定之前都只会修改this.newSettings和this.styleMergeObj,
        // 点击确认进行表单校验后才会调用emitComponentEdited，真正修改组件属性
        async handleConfirmBtnClick() {
            console.log("Component执行保存逻辑")
            // 验证所有表单规则
            // await Promise.all(
            // 	[
            // 		this.$refs["universalForm"].validate(),
            // 		// this.$refs["universalForm2"].validate(),
            // 		//this.$refs.editorForm.init(),
            // 		...this.formList.map(form => {
            // 			return this.$refs[form].validate()
            // 		})
            // 	]
            // ).then(res => {
            // 	let allFormsValid = res.every(valid => valid)
            // 	let eventLegal = this.newEvents.every(event => {
            // 		return event.trigger && event.target && event.action
            // 	})
            // 	// eslint-disable-next-line no-unused-vars
            // 	let variableEventLegal = this.newVariablesEvents.every(event => {
            // 		return event.trigger && event.variable && event.value
            // 	})
            // 	if(!allFormsValid) {
            // 		this.$refs.collapse.$children[0].$children.forEach(collapseItem => {
            // 			collapseItem.init()
            // 		})
            // 		return
            // 	}
            // 	if(!eventLegal) {
            // 		this.$refs.uToast.show({
            // 			type: 'error',
            // 			title: '不能存在空事件！',
            // 		})
            // 		return
            // 	}

            this.emitComponentEdited()
            // this.$message({
            //     type: 'success',
            //     message: '设置成功！',
            // })
            // })
        },
        // emit component-edited 事件，将组件的settings替换为this.newSettings, 并将其style与this.styleMergeObj进行合并。详见create.vue
        emitComponentEdited() {
            this.$emit("component-edited", this.newSettings, this.styleMergeObj, this.wrapperStyleMergeObj, this.newEvents, this.newBindInfo, this.newClickEvents)
        },
        getId(val) {
          let res = 0;
          for (let i = 0; i < this.varList.length; i++) {
              if (val === this.varList[i].name) res = this.varList[i].id
          }
          return res;
        },
        // 要修改
        handleUniversalChange(val, attr) {
            let newStyleMergeObj = {
                ...this.styleMergeObj,
            }
            newStyleMergeObj[attr] = val
            this.styleMergeObj = newStyleMergeObj
            this.$set(this.wrapperStyleMergeObj, attr, val)
        },
        // handleUniversalChangeState(val,attr){
        // 	this.newSettings.state = val
        // },
        //要修改坐标距离
        handleUniversalChangePosition(val, attr) {
            this.$set(this.newSettings, attr, val)
            if (val.varName !== undefined) {  // 是对象
                this.$set(this.wrapperStyleMergeObj, attr, this.varJson[val.varName].value)
            } else {
                this.$set(this.wrapperStyleMergeObj, attr, val.replace('px', '') + 'px')
            }
        },
        // 要修改宽度高度
        handleUniversalChangeSize(val, attr) {
            console.log('改变长宽：', val, attr)
            this.$set(this.newSettings, attr, val)
            console.log('val.varName：', val.varName)
            if (val.varName !== undefined) {  // 是对象
                console.log('是对象', val.varName)
                // this.wrapperStyle.attr = this.varList[val.varName]
                console.log("this.varJson[val.varName]. = ", this.varJson[val.varName])
                this.$set(this.wrapperStyleMergeObj, attr, this.varJson[val.varName].value)
                console.log("this.wrapperStyleMergeObj = ", this.wrapperStyleMergeObj)
            } else {
                // if(val.includes('px')){
                // 	console.log('输入含px')

                this.$set(this.wrapperStyleMergeObj, attr, val.replace('px', '') + 'px')
                // }
                // else{
                // 	console.log('输入不含px')
                // 	this.$set(this.wrapperStyleMergeObj, attr, val + 'px')
                // }

            }

            // if(this.newSettings[attr].varName != undefined){  // 是对象
            // 	this.wrapperStyleMergeObj[attr] = this.varJson[this.newSettings[attr].varName].value + 'px'
            // } else{
            // 	this.wrapperStyleMergeObj[attr] = val + 'px'
            // }
        },

        getEventActionList(targetId) {
            let target = this.elementsList.find(item => item.id === targetId)  // elementsList来源？？？
            if (!target)
                return []
            return eventActionMap[target.type] ? eventActionMap[target.type] : []
        },

        handleAddClickEventBtnClick() {
            this.newClickEvents.push({
                kind: '变量控制',
                trigger: 'click',
                variable: '',       // 变量名
                value: '',          // 变量值
                show: false,
                content: '',        // 脚本内容
                id: '',             // 脚本更新的变量id
                triId: '',          // 脚本触发的id
            })
        },

        // 按钮绑定变量控制
        handleAddVariablesEventBtnClick() {
            this.newVariablesEvents.push({
                trigger: '',
                variable: '',
                value: '',
                show: false,
                content: '',
            })
        },

        genVarBindInfo(setting) {
            this.$set(this.newBindInfo, setting, this.newSettings[setting])
        }
    },
    watch: {
        // 每次正在编辑的组件id改变，就重新init
        editingId() {
            this.init()
        },
        'wrapperStyle.top'() {
            let val = (parseInt(this.wrapperStyle.top.replace('px', ''))).toString()
            this.$set(this.newSettings, "top", val)
            this.wrapperStyleMergeObj = {}
        },
        'wrapperStyle.left'() {
            let val = (parseInt(this.wrapperStyle.left.replace('px', ''))).toString()
            this.$set(this.newSettings, "left", val)
            this.wrapperStyleMergeObj = {} //避免影响wrapperStyleMergeObj和wrapperStyle合并时产生覆盖
        },
        'wrapperStyle.height'() {
            this.wrapperStyleMergeObj = {}
            if (this.settings.height.varName === undefined) {
                if(typeof(this.wrapperStyle.height)==="string"){
                    let val = (parseInt(this.wrapperStyle.height.replace('px', ''))).toString()
                    this.$set(this.newSettings, "height", val)
                }else{
                    this.$set(this.newSettings, "height", this.wrapperStyle.height.toString())
                }
            }
            //this.handleConfirmBtnClick()
        },
        'wrapperStyle.width'() {
            this.wrapperStyleMergeObj = {}
            if (this.settings.width.varName === undefined) {
                if(typeof(this.wrapperStyle.width)==="string"){
                    let val = (parseInt(this.wrapperStyle.width.replace('px', ''))).toString()
                    this.$set(this.newSettings, "width", val)
                }else{
                    this.$set(this.newSettings, "width", this.wrapperStyle.width.toString())
                }
            }
            //this.handleConfirmBtnClick()
        },
    }
}

